module.exports = __webpack_public_path__ + "static/media/view.landlix.ru_landing_2_.6fd436af.png";